import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { SharedService } from '../../../shared/shared.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { FormService } from '../../../shared/form.service';
import * as moment from 'moment';
import { TrackService } from 'src/app/services/track.service';

@Component({
  selector: 'app-details4',
  templateUrl: './details4.component.html',
  styleUrls: ['./details4.component.scss'],
  encapsulation: ViewEncapsulation.None,
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class Details4Component implements OnInit {
  parentForm;
  data;
  minDate = moment().add(1, 'days');
  maxDate = moment().add(90, 'days');

  public parseFormat = [
    'DD/MM/YYYY',
    'DD.MM.YYYY',
    'DD-MM-YYYY',
    'DDMMYYYY',
    'DD,MM,YYYY',
  ];

  public parseFormatYear = ['YYYY'];

  toText(value): string {
    return value ? value.toUpperCase() : null;
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public formService: FormService,
    public sharedService: SharedService,
    public trackService: TrackService
  ) {}

  updateControl(snapshotData) {
    this.data = snapshotData.state;
  }

  ngOnInit(): void {
    window.scrollTo({ top: 0 });
    this.parentForm = this.formService.currentForm;
    if (this.parentForm.get('insuranceStart').value === null  || this.parentForm.get('insuranceStart').value == undefined)
      this.parentForm.get('insuranceStart').setValue(moment().add(1, 'days'));


      if(typeof(this.parentForm.value.companyBeneficiaryData)!=undefined){
        this.sharedService.bnfBank$.pipe(map((banks:any) => banks.find(bank => bank.id === this.parentForm.controls.companyBeneficiaryData?.value?.id))).subscribe(res => {
          if (res != undefined) this.parentForm.controls.companyBeneficiaryData.value = res
        });
      }

      // if(typeof(this.parentForm.controls.insuranceStart.value)=='string'){
      //   this.parentForm.get('insuranceStart').setValue(moment(this.parentForm.controls.insuranceStart.value, "DD.MM.YYYY").add(1, 'days').format())
      // }

    let snapshotData: any = this.route.snapshot?.data;
    this.updateControl(snapshotData);
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        snapshotData = this.route.snapshot?.data;
        this.updateControl(snapshotData);
      });
  }

  chosenDateHandler(value) {

    if(value!==null){
      let formattedDate = value.format('YYYY-MM-DD');
      if (moment() <= value && this.maxDate >= value) {
        this.parentForm.controls.insuranceStart.setErrors(null);
        this.trackService.addAttribute(
          'propertyDetails.startingDate',
          formattedDate
        );
        return;
      }
      // this.parentForm.controls.insuranceStart.setValue(value._i);
      this.parentForm.controls.insuranceStart.setErrors({
        incorrect: true,
      });
      this.trackService.addAttribute(
        'propertyDetails.startingDate',
        formattedDate
      );
    }
    this.trackService.checkErrors( this.parentForm.controls.insuranceStart, 'Insurance start date')

 
  }
}
